export default __webpack_public_path__ + "static/media/charm-3.022c8d52.png";